import Handler from "../Handler";

class LobbyReconnectionAckHandler extends Handler {
    execute(message) {
        // {"playerName":"cbdev3","profilePic":"https://images.a23games.in/avatars/poker_avatar.png"}
        let receivedData = JSON.parse(message);
        this.service.reconnectionAck(receivedData);
    }
}
export default LobbyReconnectionAckHandler;